import { CORE_API, PUSHER } from 'config';
import Pusher, { Channel } from 'pusher-js';

type PusherCallback = (args: { sender_uuid: string; patient_uuid: string }) => void;

export default class PusherService {
  private readonly client: Pusher;

  constructor(providerToken: string | undefined) {
    this.client = new Pusher(PUSHER.key, {
      cluster: PUSHER.cluster,
      authEndpoint: `${CORE_API.url}/v1/messages/pusher_auth/${providerToken}`,
    });
  }

  subscribeAndBind(channelName: string, binding: { callback: PusherCallback; eventName: string }) {
    const channel = this.client.subscribe(channelName);

    const { eventName, callback } = binding;
    channel.bind(eventName, callback);

    return channel;
  }

  disconnect(channels: Channel[]) {
    for (const channel of channels) {
      channel.unbind_all();
      channel.unsubscribe();
    }

    this.client.disconnect();
  }
}
